// src/directives/scrollOnFocus.js
export default {
  bind(el, binding) {
    const defaultOptions = {
      delay: 1000,
      behavior: 'smooth',
      block: 'center',
    };

    const options = binding.value && typeof binding.value === 'object'
      ? { ...defaultOptions, ...binding.value }
      : defaultOptions;

    let scrolled = false;

    const tryScroll = () => {
      if (scrolled) return;
      scrolled = true;
      setTimeout(() => {
        el.scrollIntoView({
          behavior: options.behavior,
          block: options.block,
        });
      }, options.delay);
    };

    const onFocus = () => {
      scrolled = false;
      window.addEventListener('resize', tryScroll, { once: true });
      setTimeout(tryScroll, 800); // 兜底：800ms 后强制滚动
    };

    el.addEventListener('focus', onFocus);
    el._scrollFocusHandler = onFocus;
  },
  unbind(el) {
    if (el._scrollFocusHandler) {
      el.removeEventListener('focus', el._scrollFocusHandler);
    }
  },
};